import React, { useEffect } from "react";
import Blocks from "blocks";
import { trackEvent } from "../../helpers";
import usePage from "./usePage";
import PageLoading from "components/loading/page-loading";
import Error from "components/error";
import NotFound from "components/notfound";
import IframePage from "components/iframepage";
import NewsArticle from "components/news-article";
import SimpleTextPage from "components/simple-text-page";
import { AlertContext } from "components/alert-bar/useAlertContext";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import "./page.scss";

import SeomaticHelmet from "components/seomatic-helmet";
import {DataPrivacyCenterPageBuilder} from "../data-privacy-center-page/data-privacy-center-page";
import BlogArticle from "../blog-article";

const PageBuilder = ({ entry }) => {
  const { pageBuilder, ...rest } = entry;

  return (
    <div className="Page">
      <Blocks blocks={pageBuilder} entry={rest} />
    </div>
  );
};

const entryTypes = {
  page: PageBuilder,
  iframePage: IframePage,
  news: NewsArticle,
  blog: BlogArticle,
  simpleTextPage: SimpleTextPage,
  clubdataprivacycenterpage: DataPrivacyCenterPageBuilder,
};

const Page = () => {
  // v6 stopped passing route props to the routed component, so the matched path
  // comes from the hook instead of `match.url`. The value is the same: none of
  // these routes are nested, so the match always covered the whole pathname.
  const { pathname } = useLocation();
  let url = pathname.replace("/", "");

  if (url.slice(-1) === '/') {
    url = url.substring(0, url.length - 1);
  }

  const { loading, error, data } = usePage(url);
  const { show, hide } = useContext(AlertContext);

  useEffect(() => {
    if (data && data.entry) {
      if (data.entry.showAlertBar !== undefined) {
        if (data.entry.showAlertBar) {
          show();
        } else {
          hide();
        }
      }
    }
  }, [data, hide, show]);

  useEffect(() => {
    if (data && data.entry && data.entry.abTest && data.entry.abTest[0] && data.entry.abTest[0]['__typename'] === 'ab_result') {
      let experimentID = data.entry.abTest[0].id;

      trackEvent({
        category: 'ABTest',
        action: 'Page Variant',
        value: data.entry.abTest[0].id.toString(),
        label: data.entry.abTest[0].id.toString()
      });
    }
  }, [data ? data.entry : false]);

  if (loading) {
    return <PageLoading />;
  }
  if (error) {
    return <Error />;
  }

  if (data && !data.entry) {
    return <NotFound />;
  }

  if (loading === false && data === undefined && error === undefined) {
    return <Error />;
  }

  const Comp = entryTypes[data.entry.typeHandle];

  return (
    <>
      <SeomaticHelmet seomatic={data.seomatic} />
      <Comp entry={data.entry} />
    </>
  );
};

export default Page;
